import { appendDataToListTable, renderListError } from '../crud/shared.js';
import { PageTitle } from '../../components.js';
import { Page } from '../base.js';

class BrandsListRow {
  static props = ['href', 'name', 'slug', 'domain', 'createdAt', 'userEmail'];
  static timl = `
    td
      a[href="{{ Props.href }}"] {{ Props.name }}
    td.pr-4 {{ Props.slug }}
    td.pr-4 {{ Props.domain }}
    td.table-col-100.pr-4[style="white-space:nowrap;"] {{ Props.createdAt }}
    td.table-col-100 {{ Props.userEmail }}
  `;
}

export class BrandsList extends Page {
  static timlComponents = {
    PageTitle
  };

  static timl = `
    a.list-view-add-button.create-button[href="/brands/create"] Create brand
    <PageTitle title="Brands">
    table.resource-table[data-empty-title="No brands yet" data-empty-description="Create a brand to manage your identity and support details." data-empty-action="Create brand" data-empty-href="/brands/create"]
      thead
        th Name
        th.pr-4 Slug
        th.pr-4 Domain
        th.table-col-100.pr-4 Created At
        th.table-col-100 Created By
      tbody#brands-list-rows.fade
  `;

  static javascript() {
    API.get(API.resourceUrl('brands'))
      .then(response => {
        appendDataToListTable('#brands-list-rows', response.data, BrandsListRow, this.mapItemToRowData);
      })
      .catch(error => renderListError('#brands-list-rows', error, 'Brands'));
  }

  static mapItemToRowData(item) {
    return {
      href: `${location.href}/${item.id}#${item.name}`,
      name: item.name,
      slug: item.slug || '',
      domain: item.domain || '',
      createdAt: Util.formatDate(item.createdAt),
      userEmail: item.createdBy || ''
    };
  }
}
